import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ArrowBackCircle } from 'react-ionicons'
import SearchFilterFunction from "../Functions/SearchFilter"
import formatAmount from "../Functions/FormatCurrency";
import stylesASAP from "./stylesASAP"

export default class Statement extends React.Component {

    constructor() {
        super();
        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            items: [],
            itemsCopy: [],
            clientId: '',
            loading: false,
            noData: true,
        }
    }

    onGo = () => {
        this.setState({ loading: true });
        const itemid = JSON.parse(localStorage.getItem('ClientId'));
        const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
        const currentFromMonth = months[this.state.fromDate.getMonth()];
        const currentToMonth = months[this.state.toDate.getMonth()];
        const fDate = this.state.fromDate.getFullYear() + '-' + currentFromMonth + '-' + this.state.fromDate.getDate();
        const tDate = this.state.toDate.getFullYear() + '-' + currentToMonth + '-' + this.state.toDate.getDate();
        const url = this.state.originalUrl2 + "loginController/getStatements/" + fDate + "/" + tDate + "/" + itemid;
        this.setState({ URL2: url });
        this._get(url).then((data) => {
            this.setState({ items: data.value, itemsCopy: data.value, loading: false });
        })
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.items, this.state.itemsCopy, this.state.noData);
        this.setState({ items: values.items, noData: values.noData })
    }

    handleDetails = (id) => {
        localStorage.setItem("IdClientDetails", JSON.stringify(id));
        this.props.history.push("./StatmentDetails");
    }

    render() {
        return (
            <div className="container-fluid vh-100" style={stylesASAP.mainBackgroundColor}>
                <div className="pt-3">
                    <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./Client")}
                        color={'#00bfff'}
                        height="50px"
                        width="50px"
                    />
                </div>
                <div className="col d-flex flex-row-reverse">
                    <div className="btn" style={stylesASAP.saveButtont} height="50px"
                        width="50px"onClick={() => this.onGo()}>Go</div>
                </div>
                <hr/>
                <div className="row pt-3">
                    <div className="col-sm-5">
                        <div className="row">
                            <div className="col-sm-2">
                                <p>From: </p>
                            </div>
                            <div className="col-sm-10">
                                <DatePicker selected={this.state.fromDate} onChange={(date) => this.setState({ fromDate: date })} />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-5">
                        <div className="row">
                            <div className="col-sm-2">
                                <p>To: </p>
                            </div>
                            <div className="col-sm-10">
                                <DatePicker selected={this.state.toDate} onChange={(date) => this.setState({ toDate: date })} />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="pt-3">
                    <input type="text" className="form-control" placeholder="Search Here" onChange={(text) => this.onSearch(text)} />
                </div>

                <p className="pt-3 text-center h3">Statement List</p>
                <div className="pt-4">
                    <div className="row">
                        <h5 className="col-sm-3">Posting Date</h5>
                        <h5 className="col-sm-2">Description</h5>
                        <h5 className="col-sm-2">Creditor</h5>
                        <h5 className="col-sm-2">Debitor</h5>
                        <h5 className="col-sm-3">Balance</h5>
                    </div>
                    {(this.state.loading) ?
                        <div className="pt-3 text-center">
                            <div className="spinner-border" style={stylesASAP.spinner}></div>
                        </div> :
                        this.state.items.map((item, index) => {
                            return (
                                <div className="pt-3" style={stylesASAP.mainBackgroundColor} key={index}>
                                    <div className="bg-light" style={{ cursor: 'pointer' }} onClick={() => this.handleDetails(item.Id)}>
                                        <div className="row">
                                            <div className="col-sm-3">{item.PostingDate}</div>
                                            <div className="col-sm-2">{item.Description}</div>
                                            <div className="col-sm-2">{formatAmount(item.CreditAmountLCY)}</div>
                                            <div className="col-sm-2">{formatAmount(item.DebitAmountLCY)}</div>
                                            <div className="col-sm-3">{formatAmount(item.CreditAmountLCY)}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}
